/**
 * @typedef AuthResult
 * @type Object
 * @property {string} errorCode Error code returned
 * @property {string} errorDescription Error description returned
 * @property {string} userId The user ID - undefined if error
 * @property {string} accessToken Access Token - undefined if error
 */
class AuthResult {
    constructor(error, userId, accessToken, url) {
        if (error) {
            this.errorCode = Number(error.Code);
            this.errorMessage = error.Description;
        }

        this.userId = userId;
        this.accessToken = accessToken;
        this.url = url;
        this._authUrl = null;
    }

    /**
     * Returns whether the result was a success
     * @returns {boolean}
     */
    get isSuccess() {
        return !this.errorCode;
    }

    /**
     * Factory for failed AuthResults
     * @param {string} message The error message from the server
     */
    static Fail(error) {
        return new AuthResult(error);
    }

    /**
     * Factory for successful AuthResults
     * @param {string} userId The user ID from the server
     * @param {string} accessToken The token from the server
     */
    static Success(data) {
        let info = data.VoiceStackInfo;
        return new AuthResult(null, info.UserId, info.AccessToken, info.Uri);
    }
}

class AuthService {
    constructor($q, $http, $log, $location, $routeParams) {
        this._q = $q;
        this._http = $http;
        this._log = $log;
        this._location = $location;
        this._params = $routeParams;
        this._validDomains = [ 'wavecloudconnect', 'waveoncloud' ];
    }

    /**
     * Authenticate against provisioning server
     * @param {string} server The provisioning server URL.
     * @param {string} username Voice stack username.
     * @param {string} password Voice stack password.
     * @return {AuthResult}
     */
    getToken(server, username, password) {

        let credentials = {username, password, scopes: 'voice_stack_access'};

        return this._http({
            method: 'POST',
            url: server,
            data: $.param(credentials),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })
        .then((response) => {
            this._log.info("AuthService.getToken SUCCESS: ", response.data);
            return AuthResult.Success(response.data);
        })
        .catch((err) => {
            this._log.error("AuthService.getToken ERROR: ", err.data ? err.data[0] : err);

            if (err.status < 0)
                throw new Error("Could not connect to provisioning server at " + server);
            else
                return AuthResult.Fail(err.data[0]);
        });
    }

    getAuthFragment(path) {
            let regex = /https:\/\/(.*)\.(.*)\.com/;
            let match = regex.exec(path);

            if (match && match.length === 3) {
                let env = match[1].split('-')[0];
                let domain = match[2];

                if (this._validDomains.includes(match[2])) {
                    let oAuthPath = 'WaveIdps/OAuth2Token';
                    if (env === 'voice') {
                        return `https://prod.${domain}.com/${oAuthPath}`;
                    } else {
                        return `https://${env}.${domain}.com/${oAuthPath}`;
                    }
                }
            }

            return "";
    }

    getAuthUrl() {
        var _this = this;
        if(this._authUrl) {
            return this._q.when(this._authUrl);
        } else if( this._params.mode && this._params.mode === 'oncloud') {
            /*let path = this._location.absUrl();
            this._authUrl = this.getAuthFragment(path);
            return this._authUrl;*/
            return this._http.get('oauth.json')
                .then((response) => {
                    _this._authUrl = response.data.oauthurl;
                    return _this._authUrl;
                })
                .catch(() => {
                    throw new Error("Server is not configured for WAVE OnCloud");
                });
        } else {
            return this._q.when(null);
        }
    }

    get authUrlPath() {
        if (this.authUrl)
            return `/oncloud`;
        else
            return "/";
    }

    get loginPath() {
        if (this.authUrl)
            return this.authUrlPath;
        else {
            if(this._params.mode)
                return `/${this._params.mode}`;
            else
                return '/';
        }
    }
}

angular.module('webcomm').service('authService', ['$q', '$http', '$log', '$location', '$routeParams', AuthService]);

/*
 POST http://dev.wavecloudconnect.com/presentation/WaveIdps/OAuth2Token
 HEADERS
 Accept: application/json
 BODY (url x-www-form-urlencoded):
 username:rdtg76@motorolasolutions.com
 password:xxxxxxxxx1
 scopes:voice_stack_access

 Error:
 [
 {
 "Code": "3",
 "Description": "No VoiceStack access"
 }
 ]
 Success:
 {
 "VoiceStackInfo": {
 "Uri": "http://waas-mgmt-wps1.wavecloudconnect.com/",
 "UserId": "{15501d52-9d03-4cff-b193-e85613167de3}",
 "AccessToken": "xxx"
 }
 }

 http://dev.wavecloudconnect.com/Presentation/Dashboard
 */